import React from 'react';

import MUIDrawer from '@mui/material/Drawer';
import {styled} from '@mui/material/styles';
import {withDarkTheme} from '@app/styles';

export const Drawer = styled(MUIDrawer)(({theme}) => ({
  width: theme.mixins.leftSidebar.width,
  '& .MuiDrawer-paper': {
    position: 'absolute',
    overflow: 'visible',
  },
  '& .MuiDrawer-paperAnchorLeft': {
    width: theme.mixins.leftSidebar.width,
  },
  '& .MuiDrawer-paperAnchorRight': {
    width: theme.mixins.rightSidebar.width,
    backgroundColor: theme.palette.grey[800],
  },
}));

export const LeftDrawer = props => (
  <Drawer anchor="left" variant="persistent" {...props} />
);

export const RightDrawer = withDarkTheme(props => (
  <Drawer anchor="right" variant="persistent" {...props} />
));

export const LeftTemporaryDrawer = props => {
  // props get injected on mount and this is the only way to update modal style
  const ModalProps = {
    keepMounted: true,
    sx: {
      zIndex: 'drawer',
      top: theme => theme.mixins.topNav.height,
      left: theme => theme.mixins.sideNav.width,
    },
    BackdropProps: {
      sx: {
        top: theme => theme.mixins.topNav.height,
        left: theme => theme.mixins.sideNav.width,
      },
    },
  };

  return <Drawer anchor="left" ModalProps={ModalProps} {...props} />;
};
